import { cn } from "@/lib/utils"
import { useEffect } from "react"

const Loading = () => {
  useEffect(() => {
    const originalOverflow = document.body.style.overflow
    document.body.style.overflow = "hidden"
    return () => {
      document.body.style.overflow = originalOverflow
    }
  }, [])

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
      <div className="relative">
        {/* Outer rotating gear */}
        <div className="absolute -inset-4 animate-spin">
          <svg
            className="h-32 w-32 text-primary"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
              fill="currentColor"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M12 3C11.175 3 10.5 3.675 10.5 4.5V4.74C10.5 5.385 10.065 5.955 9.45 6.165C9.21 6.255 8.985 6.375 8.76 6.495C8.175 6.825 7.455 6.75 6.96 6.255L6.795 6.09C6.225 5.52 5.28 5.52 4.71 6.09L3.09 7.71C2.52 8.28 2.52 9.225 3.09 9.795L3.255 9.96C3.75 10.455 3.825 11.175 3.495 11.76C3.375 11.985 3.255 12.21 3.165 12.45C2.955 13.065 2.385 13.5 1.74 13.5H1.5C0.675 13.5 0 14.175 0 15V17.25C0 18.075 0.675 18.75 1.5 18.75H1.74C2.385 18.75 2.955 19.185 3.165 19.8C3.255 20.04 3.375 20.265 3.495 20.49C3.825 21.075 3.75 21.795 3.255 22.29L3.09 22.455C2.52 23.025 2.52 23.97 3.09 24.54L4.71 26.16C5.28 26.73 6.225 26.73 6.795 26.16L6.96 25.995C7.455 25.5 8.175 25.425 8.76 25.755C8.985 25.875 9.21 25.995 9.45 26.085C10.065 26.295 10.5 26.865 10.5 27.51V27.75C10.5 28.575 11.175 29.25 12 29.25H14.25C15.075 29.25 15.75 28.575 15.75 27.75V27.51C15.75 26.865 16.185 26.295 16.8 26.085C17.04 25.995 17.265 25.875 17.49 25.755C18.075 25.425 18.795 25.5 19.29 25.995L19.455 26.16C20.025 26.73 20.97 26.73 21.54 26.16L23.16 24.54C23.73 23.97 23.73 23.025 23.16 22.455L22.995 22.29C22.5 21.795 22.425 21.075 22.755 20.49C22.875 20.265 22.995 20.04 23.085 19.8C23.295 19.185 23.865 18.75 24.51 18.75H24.75C25.575 18.75 26.25 18.075 26.25 17.25V15C26.25 14.175 25.575 13.5 24.75 13.5H24.51C23.865 13.5 23.295 13.065 23.085 12.45C22.995 12.21 22.875 11.985 22.755 11.76C22.425 11.175 22.5 10.455 22.995 9.96L23.16 9.795C23.73 9.225 23.73 8.28 23.16 7.71L21.54 6.09C20.97 5.52 20.025 5.52 19.455 6.09L19.29 6.255C18.795 6.75 18.075 6.825 17.49 6.495C17.265 6.375 17.04 6.255 16.8 6.165C16.185 5.955 15.75 5.385 15.75 4.74V4.5C15.75 3.675 15.075 3 14.25 3H12Z"
              fill="currentColor"
              fillOpacity="0.2"
            />
          </svg>
        </div>

        {/* Inner rotating gear */}
        <div className="animate-spin-reverse">
          <svg
            className="h-24 w-24 text-primary"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
              fill="currentColor"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M12 3C11.175 3 10.5 3.675 10.5 4.5V4.74C10.5 5.385 10.065 5.955 9.45 6.165C9.21 6.255 8.985 6.375 8.76 6.495C8.175 6.825 7.455 6.75 6.96 6.255L6.795 6.09C6.225 5.52 5.28 5.52 4.71 6.09L3.09 7.71C2.52 8.28 2.52 9.225 3.09 9.795L3.255 9.96C3.75 10.455 3.825 11.175 3.495 11.76C3.375 11.985 3.255 12.21 3.165 12.45C2.955 13.065 2.385 13.5 1.74 13.5H1.5C0.675 13.5 0 14.175 0 15V17.25C0 18.075 0.675 18.75 1.5 18.75H1.74C2.385 18.75 2.955 19.185 3.165 19.8C3.255 20.04 3.375 20.265 3.495 20.49C3.825 21.075 3.75 21.795 3.255 22.29L3.09 22.455C2.52 23.025 2.52 23.97 3.09 24.54L4.71 26.16C5.28 26.73 6.225 26.73 6.795 26.16L6.96 25.995C7.455 25.5 8.175 25.425 8.76 25.755C8.985 25.875 9.21 25.995 9.45 26.085C10.065 26.295 10.5 26.865 10.5 27.51V27.75C10.5 28.575 11.175 29.25 12 29.25H14.25C15.075 29.25 15.75 28.575 15.75 27.75V27.51C15.75 26.865 16.185 26.295 16.8 26.085C17.04 25.995 17.265 25.875 17.49 25.755C18.075 25.425 18.795 25.5 19.29 25.995L19.455 26.16C20.025 26.73 20.97 26.73 21.54 26.16L23.16 24.54C23.73 23.97 23.73 23.025 23.16 22.455L22.995 22.29C22.5 21.795 22.425 21.075 22.755 20.49C22.875 20.265 22.995 20.04 23.085 19.8C23.295 19.185 23.865 18.75 24.51 18.75H24.75C25.575 18.75 26.25 18.075 26.25 17.25V15C26.25 14.175 25.575 13.5 24.75 13.5H24.51C23.865 13.5 23.295 13.065 23.085 12.45C22.995 12.21 22.875 11.985 22.755 11.76C22.425 11.175 22.5 10.455 22.995 9.96L23.16 9.795C23.73 9.225 23.73 8.28 23.16 7.71L21.54 6.09C20.97 5.52 20.025 5.52 19.455 6.09L19.29 6.255C18.795 6.75 18.075 6.825 17.49 6.495C17.265 6.375 17.04 6.255 16.8 6.165C16.185 5.955 15.75 5.385 15.75 4.74V4.5C15.75 3.675 15.075 3 14.25 3H12Z"
              fill="currentColor"
              fillOpacity="0.7"
            />
          </svg>
        </div>

        {/* Loading text */}
        <div className="absolute left-1/2 top-full mt-4 -translate-x-1/2 text-center">
          <p className="text-lg font-semibold text-primary animate-pulse">
            Loading...
          </p>
        </div>
      </div>
    </div>
  )
}

export default Loading